import { processColor } from "react-native";

function crCalculateBlend(a1, a2, c1, c2) {
    return (c1 * a1 * (1.0 - a2) + c2 * a2) / (a1 + a2 - a1 * a2);
}

function crColorBlend(cor1, cor2) {
    var fAlp1 = cor1.alpha / 255.0;
    var fAlp2 = cor2.alpha / 255.0;
    var fAlpBlend = fAlp1 + fAlp2 - fAlp1 * fAlp2;

    var fRed1 = cor1.red / 255.0;
    var fRed2 = cor2.red / 255.0;
    var fRedBlend = crCalculateBlend(fAlp1, fAlp2, fRed1, fRed2);

    var fGreen1 = cor1.green / 255.0;
    var fGreen2 = cor2.green / 255.0;
    var fGreenBlend = crCalculateBlend(fAlp1, fAlp2, fGreen1, fGreen2);

    var fBlue1 = cor1.blue / 255.0;
    var fBlue2 = cor2.blue / 255.0;
    var fBlueBlend = crCalculateBlend(fAlp1, fAlp2, fBlue1, fBlue2);

    return {
        alpha: parseInt(fAlpBlend * 255),
        red: parseInt(fRedBlend * 255),
        green: parseInt(fGreenBlend * 255),
        blue: parseInt(fBlueBlend * 255),
    };
}

export function blendColor(c1, c2) {
    var color1 = processColor(c1);
    var cor1 = {
        alpha: (color1 & 0xff000000) >> 24,
        red: (color1 & 0x00ff0000) >> 16,
        green: (color1 & 0x0000ff00) >> 8,
        blue: color1 & 0x000000ff,
    };
    var color2 = processColor(c2);
    var cor2 = {
        alpha: (color2 & 0xff000000) >> 24,
        red: (color2 & 0x00ff0000) >> 16,
        green: (color2 & 0x0000ff00) >> 8,
        blue: color2 & 0x000000ff,
    };
    if (cor1.alpha < 0) {
        cor1.alpha = 255;
    }
    if (cor2.alpha < 0) {
        cor2.alpha = 255;
    }
    var r = crColorBlend(cor1, cor2);
    return `rgba(${r.red}, ${r.green}, ${r.blue}, ${r.alpha / 255.0})`;
}
